// extracted by mini-css-extract-plugin
module.exports = {"container":"Statements_container__3_C6H","header":"Statements_header__1b3G6","statementContent":"Statements_statementContent__1KoR6"};